import lazyLoad from 'core/util/lazyLoad';

const OverviewMap = lazyLoad(() => import('./OverviewMap'));

export default OverviewMap;
